@if (isPublicSignup) {
  <div class="flex justify-center items-center min-h-screen p-4 bg-surface-50 dark:bg-gray-900">
    <p-card class="w-full max-w-lg" header="Create {{ organisationAlias }}">
      <app-new-organisation [isStart]="true" />
    </p-card>
  </div>
} @else {
  <div class="relative isolate bg-white dark:bg-surface-950 px-6 py-12 sm:py-16 lg:px-8">
    <div class="mx-auto max-w-4xl text-center">
      <h2 class="text-base/7 font-semibold text-primary">No {{ organisationAlias }} Found</h2>
      <p class="mt-2 text-5xl font-semibold tracking-tight text-balance sm:text-6xl">Contact Administrator</p>
    </div>
    <div class="mx-auto mt-6 max-w-2xl text-center">
      <p class="text-lg font-medium text-pretty sm:text-xl/8 mb-8">
        You are not a member of any {{ organisationAlias | lowercase }}. Please contact your administrator to resolve this issue.
      </p>
      <div class="flex gap-4 flex-col items-center">
        <a
          aria-label="Contact Administrator"
          icon="pi pi-envelope"
          label="Contact Administrator"
          pButton
          pRipple
          severity="primary"
          [href]="'mailto:' + contactEmail"></a>
        <button
          aria-label="Sign Out"
          icon="pi pi-sign-out"
          label="Sign Out"
          pButton
          routerLink="/login"
          severity="secondary"
          type="button"
          (click)="signOut()"></button>
      </div>
    </div>
  </div>
}
